/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  LicenseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LicenseDtoFromJSON,
    LicenseDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class LicenseApi extends runtime.BaseAPI {

    /**
     * Get information about the customer\'s current license along with all enabled features.
     * Get License information
     */
    async getLicenseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LicenseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/license`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LicenseDtoFromJSON(jsonValue));
    }

    /**
     * Get information about the customer\'s current license along with all enabled features.
     * Get License information
     */
    async getLicense(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LicenseDto> {
        const response = await this.getLicenseRaw(initOverrides);
        return await response.value();
    }

}
